import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
export default async function guestGetToken({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/guest/get/token', config.api.url);
  const result = await client.get(url.href, { params });
  return result?.data?.data;
}
